import { AspectRatio, Badge, Box, Button, Card, Container, Flex, Group, Image, Stack, Text } from "@mantine/core"
import { IconDownload, IconExternalLink, IconEye, IconHelpCircle } from "@tabler/icons-react"

const CommunityResourceCard = ({ item }) => {

    const current_tags = Array.isArray(item?.tags) ? item.tags : item?.tags?.split(',')

    return (
        <Container maw='400px'>
            <Card withBorder radius="md" shadow="sm" p="md" transition="all 0.2s ease">

                <Card.Section mb="sm" pos='relative'>
                    <Flex
                        style={{ zIndex: 10 }}
                        pos='absolute'
                        justify='start'
                        right={0}
                        p={10}
                        gap={10}
                        w='100%'
                        top={0}
                    >
                        <Button
                            type='button'
                            color='var(--color-secondary-darkest)'
                            leftSection={<IconEye size={18} />}
                        >
                            Ver más
                        </Button>
                        {item.tutorial_url &&
                            <Button
                                target='_blank'
                                color='var(--color-primary-light)'
                                leftSection={<IconHelpCircle />}
                                component='a'
                                variant='filled'
                                href={item.tutorial_url}
                            >
                                Tutorial
                            </Button>
                        }
                    </Flex>
                    {item.type === 'video' && item.external_url ? (
                        <AspectRatio ratio={16 / 9}>
                            <iframe
                                src={item.external_url}
                                title={item.title}
                                style={{ border: 0 }}
                                allowFullScreen
                            />
                        </AspectRatio>
                    ) : (
                        <Image
                            src={item.preview_url || 'https://placehold.co/600x400/0ca678/white?text=FORVET'}
                            height={180}
                            alt={item.title}
                            fallbackSrc="https://placehold.co/600x400?text=Cargando..."
                        />
                    )}
                </Card.Section>


                <Stack justify="space-between" h="100%" style={{ flexGrow: 1 }}>
                    <Box>
                        <Group justify="space-between" mb="xs">
                            <Badge color="var(--color-tertiary)" variant="dot" size="sm">{item.type}</Badge>
                            <Group gap={5}>
                                {current_tags && current_tags.map(tag => (
                                    <Badge color='var(--color-tertiary)' variant='outline' size='xs'>#{tag}</Badge>
                                ))}
                            </Group>
                        </Group>
                        <Text fw={700} size="lg" mb={5} lineClamp={1}>{item.title}</Text>
                        <Text size="sm" c="dimmed" lineClamp={3}>
                            {item.description || "Sin descripción disponible."}
                        </Text>
                    </Box>


                    <Stack gap="xs" mt="md">
                        {item.external_url && (
                            <Button
                                component="a"
                                href={item.external_url}
                                target="_blank"
                                fullWidth
                                variant="light"
                                leftSection={<IconExternalLink size={18} />}
                            >
                                Abrir Enlace
                            </Button>
                        )}
                        {item.download_url && (
                            <Button
                                fullWidth
                                variant="light"
                                color='var(--color-tertiary)'
                                leftSection={<IconDownload size={18} />}
                            >
                                Descargar
                            </Button>
                        )}
                    </Stack>
                </Stack>
            </Card>
        </Container>
    )
}

export default CommunityResourceCard